import Cookies from 'js-cookie';

class ErrorReportService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.ERROR_REPORT = '/api/error-report';
        this.LOG_ERROR = '/log';
    }

    async logErrorReport(errorBody){
        try{
            let url = window.location.origin + this.ERROR_REPORT + this.LOG_ERROR;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: errorBody
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        localStorage.setItem('errorUUID', data.uuid);
                    }
                    return data;
                });
        }
        catch(err){
            console.log(err);
        }
    }
}

export default ErrorReportService;
